/* eslint-disable */
import { FormRecordFieldView, FormRecordFieldViewFactory } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector } from '@angular/core';
import { FormRecordProcessOrderStockOuttakeFieldComponent } from '../../admin/form/form-record/fields/process-order-stock-outtake/form-record-process-order-stock-outtake-field.component';
/* eslint-enable */

export class FormRecordProcessOrderStockOuttakeFieldViewFactory implements FormRecordFieldViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createView(): ComponentRef<FormRecordFieldView> {
    const cmp = this.cfr.resolveComponentFactory(FormRecordProcessOrderStockOuttakeFieldComponent)
      .create(this.injector);
    return cmp;
  }

}
